import type { AIProviderId } from '@creanizer/types'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787'

export async function testProviderConnection(
  provider: AIProviderId,
  apiKey: string
): Promise<void> {
  const response = await fetch(`${API_URL}/api/v1/providers/test`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': apiKey,
    },
    body: JSON.stringify({ provider }),
  })

  if (response.ok) return
  const error = await response.json().catch(() => null) as {
    message?: string
  } | null
  throw new Error(error?.message ?? `接続テストに失敗しました (${response.status})`)
}
